import { type FC } from 'react';
import { Trans } from 'react-i18next';
import VipIcon from '@assets/img/icons/vip-icon.svg?react';

import { TextSmall } from '@/components/Typography/Typography';

import { MyReferralRewardTable } from '../MyReferralRewardTable/MyReferralRewardTable';

import { EarnCashAndCoinButton } from './EarnCashAndCoinButton/EarnCashAndCoinButton';
import { MyPartnersButton } from './MyPartnersButton/MyPartnersButton';

import css from './styles.module.scss';

const EarnCashAndCoin: FC = () => {
  return (
    <div className="w-full px-2">
      <div className={css.earnCashAncCoin}>
        <EarnCashAndCoinButton />
        <MyReferralRewardTable className="px-3" />
        <div className="w-full rounded-[80px] bg-black/30 flex items-center justify-center h-8 gap-2">
          <VipIcon className="w-6 h-6 shrink-0" />
          <TextSmall weight="medium" className={css.vipLabel}>
            <Trans
              i18nKey={'Get <1>X2</1> rewards when VIP is active'}
              components={{ 1: <span /> }}
            />
          </TextSmall>
          <VipIcon className="w-6 h-6 shrink-0" />
        </div>
        <MyPartnersButton />
      </div>
    </div>
  );
};

export { EarnCashAndCoin };
